import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { SvgIcon } from '@mui/material';
export default function ProgressStartArrow(props) {
    return /*#__PURE__*/ React.createElement(SvgIcon, _extends({}, props, {
        sx: _objectSpread({
            height: '100%',
            width: '100%'
        }, props.sx)
    }), /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 160 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M145.329 0.5C146.683 0.5 147.945 1.18488 148.683 2.32005L159.083 18.32C159.945 19.6456 159.945 21.3544 159.083 22.68L148.683 38.68C147.945 39.8151 146.683 40.5 145.329 40.5H4.217C1.07526 40.5 -0.840122 37.0442 0.824998 34.38L9.5 20.5L0.824996 6.61999C-0.840124 3.9558 1.07525 0.5 4.21699 0.5L145.329 0.5Z",
        fill: "currentColor"
    })));
}
